import UploadImage from './upload-image.vue'
import UploadImageCropper from './upload-image-cropper.vue'
import UploadVideo from './upload-video.vue'
import UploadFile from './upload-file.vue'
import Examine from './examine.vue'
import User from './user.vue'
import PageHeader from './page-header.vue'
import AddPrize from './add-prize.vue'
import ActiveUpdateShipmentStatusDialog from './active-update-shipment-status-dialog'
import PhotographyContributionDetail from './photography-contribution-detail/view.vue'
import PhotographyContributionDetail2 from './photography-contribution-detail2/view.vue'
import SupplementaryContractDialog from './supplementary-contract-dialog.vue'
import UpdateShipmentStatusDialog from './update-shipment-status-dialog'
import PullNewDialog from './pull-new-dialog'
import ExamineInfo from './examine-info.vue'
import ExamineInfo2 from './examine-info2.vue'
import ExamineInfo3 from './examine-info3.vue'
import PhotographyExamineOperation from './photography-examine-operation'
import BatchExamine from './batch-examine'
import ProjectExamineOperation from './project-examine-operation'
import ProjectExamineOperation2 from './project-examine-operation2'
import UserLevelSet from './user-level-set'

const components = {
	UploadImage,
	UploadImageCropper,
	UploadVideo,
	UploadFile,
	Examine,
	User,
	PageHeader,
	AddPrize,
	ActiveUpdateShipmentStatusDialog,
	UpdateShipmentStatusDialog,
	PullNewDialog,
	PhotographyExamineOperation,
	BatchExamine,
	ExamineInfo,
	ExamineInfo2,
	ExamineInfo3,
    ProjectExamineOperation,
	ProjectExamineOperation2,
    UserLevelSet
}

function install(Vue) {
	Object.keys(components).forEach(key => {
		Vue.component(`w${key}`, components[key])
	})
}

export {
	UploadImage,
	UploadImageCropper,
	UploadVideo,
	UploadFile,
	Examine,
	User,
	PageHeader,
	AddPrize,
	ActiveUpdateShipmentStatusDialog,
	PhotographyContributionDetail,
	PhotographyContributionDetail2,
	SupplementaryContractDialog,
	UpdateShipmentStatusDialog,
	PullNewDialog,
	BatchExamine,
	ExamineInfo,
	ExamineInfo2,
	ExamineInfo3,
	PhotographyExamineOperation,
    ProjectExamineOperation,
	ProjectExamineOperation2,
    UserLevelSet
}

export default install
